import { Box, Text } from "@chakra-ui/react";
import { guidedBudgetPrimaryColor } from "./guidedBudgetEditorTokens";

export function GuidedBudgetEditorHeader() {
  return (
    <Box>
      <Text
        fontSize="md"
        fontWeight="semibold"
        color={guidedBudgetPrimaryColor}
        mb={1}
        lineHeight="1.3"
      >
        Campaign budget
      </Text>
      <Text
        fontSize="xs"
        fontWeight="medium"
        color="rgba(26, 32, 44, 0.6)"
        lineHeight="1.4"
        maxW="444px"
      >
        Meta will automatically distribute your budget to the best opportunities across your
        campaign.
      </Text>
    </Box>
  );
}
